import { LOCAL_STORAGE } from '../../data/browserStorage/constants';
import { save, load } from '../../data/browserStorage';
import { ALFRESCO_FOLDER_DATA } from '../../components/AlfrescoPicker/constants';

export default (() => {
  const _subscriptions = {};

  const subscribeToAlfrescoActivityChange = (activityId, listener) => {
    _subscriptions[activityId] = _subscriptions[activityId] || [];
    _subscriptions[activityId].push(listener);
    return _createUnsubscribe(activityId, listener);
  };

  function _createUnsubscribe(activityId, listener) {
    return () => {
      const listenerIndex = _subscriptions[activityId].indexOf(listener);
      _subscriptions[activityId].splice(listenerIndex, 1);
    };
  }

  function notifyUpdateActivityChange(broadcast) {
    if (_subscriptions[broadcast.response.elementId]) {
      const listeners = _subscriptions[broadcast.response.elementId];
      listeners.forEach((listener) => {
        listener(broadcast);
      });
    }
  }

  function setSelectedStructure(id, currentFolder) {
    const previousFolderData = load(ALFRESCO_FOLDER_DATA, LOCAL_STORAGE);
    if (!previousFolderData) {
      const folderDataWithId = {
        [id]: {
          currentFolder,
        },
      };
      save(ALFRESCO_FOLDER_DATA, JSON.stringify(folderDataWithId), LOCAL_STORAGE);
    } else {
      const previousParsedData = JSON.parse(previousFolderData);
      previousParsedData[id] = {
        currentFolder,
      };
      save(ALFRESCO_FOLDER_DATA, JSON.stringify(previousParsedData), LOCAL_STORAGE);
    }
  }

  function getSelectedStructure() {
    try {
      const alfrescoFolderData = load(ALFRESCO_FOLDER_DATA, LOCAL_STORAGE) || null;
      return JSON.parse(alfrescoFolderData);
    } catch (error) {
      return null;
    }
  }

  return {
    subscribeToAlfrescoActivityChange,
    notifyUpdateActivityChange,
    setSelectedStructure,
    getSelectedStructure,
  };
})();
